import * as React from 'react';
import { IComponent, ComponentHelper, EComponentTypes } from '../../helpers';
import { Properties } from '../';
import {
    Panel, PanelType,
    Button, ButtonType
} from 'office-ui-fabric-react';

interface IProps {
    component: IComponent;
    isOpen: boolean;
    isLayoutPanel?: boolean;
    layoutPanelIndex?: number;
    pinned: boolean;
    updateProperty: (key: string, value: any) => void;
    updateLayoutPanelProperty: (key: string, value: any, componentId: string, layoutPanelIndex: number) => void;
    toggle: () => void;
    togglePin: () => void;
    propertiesToExclude?: string[];
};

export class Sidebar extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);
    }

    public render() {

        let {
            component, isOpen, isLayoutPanel, layoutPanelIndex, pinned, updateProperty,
            updateLayoutPanelProperty, toggle, togglePin, propertiesToExclude
        } = this.props;

        if (!isOpen)
            return (null);

        return <Panel
            className={"sidebar " + (pinned ? 'pinned' : '')}
            isOpen={isOpen}
            onDismiss={() => toggle()}
            type={PanelType.medium}
            headerText={isLayoutPanel ? "Layout" : EComponentTypes[component.ComponentType.ComponentTypeId]}
            headerClassName={EComponentTypes[component.ComponentType.ComponentTypeId]}
            isLightDismiss={true}>

            <Button buttonType={ButtonType.command} title={(pinned ? "Unp" : "P") + "in sidebar"} className="pin-button" onClick={togglePin} icon={pinned ? 'PinnedFill' : 'Pinned'}></Button>

            {
                isLayoutPanel ?
                    <Properties componentId={component.Id} properties={ComponentHelper.getProperties(component, true, true, layoutPanelIndex)} primaryOnly={false} change={updateLayoutPanelProperty}
                        propertiesToExclude={propertiesToExclude} isLayoutPanel={true} layoutPanelIndex={layoutPanelIndex}
                    /> :
                    <Properties componentId={component.Id} properties={ComponentHelper.getProperties(component, true)} primaryOnly={false} change={updateProperty}
                        propertiesToExclude={propertiesToExclude} isLayoutPanel={false}
                    />
            }

        </Panel>;

    };

};


// WEBPACK FOOTER //
// ./source/ts/components/layout/sidebar.tsx